(function(){
  'use strict';  
  

  theme.Article = (function() {

    function Article(container) {
      this.container = container
      this.init()
    }
  
    Article.prototype = Object.assign({}, Article.prototype, {
      init: function() {
        this.articleMain = this.container.querySelector(".article-layout__main")
        this.articleSummary = this.container.querySelector(".article-layout__summary")

        var announcementBar = document.querySelector(".site-announcement-container")
        var siteHeader = document.querySelector(".site-header-container")
        this.headerHeight = (announcementBar? announcementBar.offsetHeight : 0) + (siteHeader ? siteHeader.offsetHeight : 0)

        var headerTags = this.articleMain.querySelectorAll("h2, h3, h4, h5, h6")

        if (headerTags.length > 1) {
          this.container.querySelector(".article-layout__summary--desktop").classList.remove("hide")
        }
        headerTags.forEach(function (item, index) {
          if (item.closest(".hide")) {
            return
          }
          var headerId = item.outerText.replace(/ /g,"-").toLowerCase()
          item.id = headerId
          
          var li = document.createElement("li");
          li.setAttribute('class','item');
          li.innerHTML = `<a href="#${headerId}">${item.outerText}</a>`; 
          li.addEventListener("click",(e)=>{
            e.preventDefault();

            const yOffset = -this.headerHeight; 
            
            const element = document.querySelector(`[id='${headerId}']`);
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset - 65;
            
            window.scrollTo({top: y, behavior: 'smooth'});
          });
          this.articleSummary.appendChild(li)
        }.bind(this));

      }       
    });
  
    return Article;
  })();

  theme.Blog = (function() {

    function Blog(container) {
      this.container = container
      this.initReadingTime();
      this.tagFilters();
      this.initInfiniteScroll();
    }
  
    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function() {
        var filterBy = document.getElementById('BlogTagFilter');
  
        if (!filterBy) {
          return;
        }
  
        filterBy.addEventListener('change', function() {
          location.href = filterBy.value;
        });
      },

      initReadingTime: function() {
        this.container.querySelectorAll(".reading-time").forEach((el) => {
          var wordsPerMinute = 200;
          var textLength = el.dataset.characters
          if(textLength > 0){
            var value = Math.ceil(textLength / wordsPerMinute);
            el.innerText = value + " " + theme.strings.minute
          }
        });
      },
      
      /**
       * Infinite scroll
       */
      initInfiniteScroll: function() {
        var viewMoreBtn = this.container.querySelector('.js-load-more')
        viewMoreBtn && viewMoreBtn.addEventListener("click", function(e) {
          var totalPages = parseInt(this.container.querySelector('[data-all-pages]').value);
          var currentPage = parseInt(this.container.querySelector('[data-current-page]').value);
          var collectionUrl = this.container.querySelector('[data-collection-url]').value;

          this.classList.add('btn--loading')

          var url = this.container.querySelector('[data-next-url]').value;
          var current_page_new = currentPage + 1;
          var nextPage = currentPage + 2;
          var nextUrl = url.replace("page=" + current_page_new,"page=" + nextPage);

          fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          })
          .then(function(response) {return response.text()})
          .then(function(html) {

            this.container.querySelector('[data-next-url]').value = nextUrl
            this.container.querySelector('[data-current-page]').value = current_page_new

            var newDom = new DOMParser().parseFromString(html, 'text/html');
            var responseHTML = newDom.querySelector('.grid-loader').innerHTML

            this.container.querySelector('.grid-loader').insertAdjacentHTML('beforeend', responseHTML); 
          })
          .then(() => {
            this.classList.remove('btn--loading');
            if(current_page_new < totalPages) {
              this.classList.remove('hide');
            } 
            if(current_page_new >= totalPages) {
              this.classList.add('hide');
            } 
          })
        })
      }
    });
  
    return Blog;
  })();

  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map ? this.map.dataset.apiKey : null;

      if (this.container.querySelector(".map-onboarding") && this.key == null) {
        var iframeMap = this.container.querySelector(".map-onboarding").firstChild
        if (iframeMap) {
          this.createiFrame(iframeMap)
        }
        
        console.log(this.container.querySelector(".map-onboarding").firstChild)
      }
      
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.Helpers.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      },

      createiFrame: function(iframeMap) {
        iframeMap.style.height = "100%"
        iframeMap.style.width = "100%"
      }
    });
  
    return Map;
  })();

  theme.Quotes = (function() {
    var defaults = {
      adaptiveHeight: true,
      pageDots: true,
      autoPlay: false,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false
    };
  
    function Quotes(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Quotes-' + sectionId);
      this.namespace = '.quote-' + sectionId;

      this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
        el.classList.remove('loading', 'loading--delayed');
        el.classList.add('loaded');
      });
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Quotes.prototype = Object.assign({}, Quotes.prototype, {
      init: function() {
        defaults.wrapAround = true;
        
        if (this.slideshow.dataset.autoplay == 'true') {
          defaults['autoPlay'] = true;
        } else {
          defaults['autoPlay'] = false;
        }
        
        if (this.slideshow.dataset.count <= 3) {
          defaults['pageDots'] = false;
          //defaults.wrapAround = false;
        } else {
          defaults['pageDots'] = true;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);

      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.quotes-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Quotes;
  })();

  
  theme.ImageComparsion = (function() {

    function ImageComparsion(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');

      this.container.querySelectorAll(".image-grid-item--loader").forEach((el) => {
        el.classList.remove('loading', 'loading--delayed');
        el.classList.add('loaded');
      });
      
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    ImageComparsion.prototype = Object.assign({}, ImageComparsion.prototype, {
      init: function() {
        var imageWidth = this.calculateSizes()
        this.initComparisons(this.container, imageWidth)
        
        var windowWidth = window.innerWidth;
        window.on('resize', theme.Helpers.debounce(250, function() {
          if (window.innerWidth != windowWidth) {windowWidth = window.innerWidth}else{return}
          imageWidth = this.calculateSizes()
          this.initComparisons(this.container, imageWidth)
        }.bind(this)));
      },

      calculateSizes: function() {
        var imageBackground = this.container.querySelector(".image-comp-1")
        var imageMobileBackground = this.container.querySelector(".image-small-comp-1")
        
        var imageForeground = this.container.querySelector(".image-comp-2")
        var imageMobileForeground = this.container.querySelector(".image-small-comp-2")
        var imageWidth = 0;
        
        if (imageBackground != null) {
          imageWidth = imageBackground.offsetWidth         
        } 
        
        if (imageWidth == 0 && imageMobileBackground != null) {
          imageWidth = imageMobileBackground.offsetWidth
        }

        if (imageForeground != null) {
          imageForeground.style.width = imageWidth + 'px';
        }
        
        if (imageMobileForeground != null) {
          imageMobileForeground.style.width = imageWidth + 'px';
        }
        
        return imageWidth
      },

      initComparisons: function(container, imageWidth) {
        var slider, img, clicked = 0, w, h;
        var img = container.querySelector(".image-comp-overlay");
        w = imageWidth;
        h = img.offsetHeight;
        img.style.width = (w / 2) + "px";

        slider = container.querySelector(".image-comp-slider");

        img.parentElement.insertBefore(slider, img);
        slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
        slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";

        slider.addEventListener("mousedown", slideReady);
        window.addEventListener("mouseup", slideFinish);
        slider.addEventListener("touchstart", slideReady);
        window.addEventListener("touchend", slideFinish);
        
        function slideReady(e) {
          e.preventDefault();
          clicked = 1;
          window.addEventListener("mousemove", slideMove);
          window.addEventListener("touchmove", slideMove);
        }
        
        function slideFinish() {
          clicked = 0;
        }
        
        function slideMove(e) {
          var pos;
          if (clicked == 0) return false;
          pos = getCursorPos(e)
          if (pos < 0) pos = 0;
          if (pos > w) pos = w;
          slide(pos);
        }
        
        function getCursorPos(e) {
          var a, x = 0;
          e = (e.changedTouches) ? e.changedTouches[0] : e;
          a = img.getBoundingClientRect();
          x = e.pageX - a.left;
          x = x - window.pageXOffset;
          return x;
        }
        
        function slide(x) {
          img.style.width = x + "px";
          slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
        }
      }
    });

    return ImageComparsion;
  })();
  
  function DOMProductready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMProductready(function(){
    theme.sections.register('article', theme.Article);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('quotes', theme.Quotes); 
    theme.sections.register('image-comparsion', theme.ImageComparsion);
  });
})();